import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueCarousel from 'vue-carousel'
import VueMeta from 'vue-meta'
import VueYouTubeEmbed from 'vue-youtube'
import { FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library} from '@fortawesome/fontawesome-svg-core'
import * as VueGoogleMaps from 'vue2-google-maps'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './animate.min.css'
import './assets/fonts/style.css'

Vue.use(BootstrapVue);
Vue.use(VueCarousel)
Vue.use(VueYouTubeEmbed)
Vue.use(VueMeta)
Vue.use(VueGoogleMaps, {
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  installComponents: true,
})

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
library.add(fab)

router.beforeEach((to, from, next) => {
	setTimeout(() => {
    // Scroll page to top
    if (to.name !== 'ExecDetails') {
      window.scrollTo(0, 0);
    } 
    else {
      window.scrollTo(0, 150);
    }
  }, 10);
  if (to.name === 'About' || to.name === 'ExecDetails') {
    store.dispatch('getExecutives').then(() => {
      if (to.name === 'ExecDetails') {
        store.dispatch('getCurrentExecutive', {
          to: to
        });
      }
    });
  } else if (to.name === 'Estates') {
    store.dispatch('getEstates');
  } else if (to.name === 'Home') {
    store.dispatch('getSliders');
  } else if (to.name === 'Privacy') {
    store.dispatch('getPrivacyData');
  } else if (to.name === 'Blog') {
    store.dispatch('getBlogData');
  } else if (to.name === 'Testimonials') {
    store.dispatch('getTestimonials');
  } else if (to.name === 'Projects'
    || to.name === 'BecomeAnAgent'
    || to.name === 'Contact') {
    store.dispatch('getSiteData').then(() => {
      if (to.name === 'Contact') {
        store.dispatch('getContactOffices')
        store.dispatch('getContactData')
      }
    });
  } else if (to.name === 'OurHouses' || to.name === 'OurHousesDetails') {
    store.dispatch('getHouses').then(() => {
      if (to.name == 'OurHousesDetails') {
        store.dispatch('getCurrentHouse', {
          to: to
        });
      }
    });
  }
	next();
});

// To Show the Progress bar
router.beforeResolve((to, from, next) => {
	store.dispatch('loadingState', true)
	next()
});

// Remove Progress Bar
router.afterEach(() => {
	store.dispatch('loadingState', false)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
